import React, { CSSProperties } from "react";
import { getHeightByViewPort } from "../../methods/getSizeByViewPort";
import { getRemValue } from "../../methods/getRemValue";
export interface ValidationErrorProps {
    error: string | undefined;
    style?: CSSProperties;
    errorClass?: string;
}

const ValidationError = ({ errorClass, error, style = {} }: ValidationErrorProps) => {
    return (
        <div
            style={{
                // height: "11px",
                color: "#FF1224",
                fontSize: getRemValue(11),
                lineHeight: getHeightByViewPort(10),
                ...style
            }}
            className={errorClass}
        >
            {error}
        </div>
    );
};

export default ValidationError;
